import classNames from 'classnames'
import { PropsWithChildren } from 'react'

import styles from './DropdownCard.module.scss'

export interface DropdownCardProps {
  className?: string
}

export const DropdownCard: React.FC<PropsWithChildren<DropdownCardProps>> = (props) => {
  const { children, className } = props

  return <div className={classNames(styles.dropdownCard, className)}>{children}</div>
}
